import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { all } from 'store/Breadcrumbs'

import { Icon } from '../Icon'

import * as S from './styled'

export type BreadcrumbsProps = {
  crumbs: any[] | null
}

export function Breadcrumbs({ crumbs }: BreadcrumbsProps) {
  const { suffix } = useSelector(all)

  if (crumbs.length === 0) return null

  if (crumbs.length === 1) {
    return (
      <S.Wrapper>
        <S.Container>
          <Icon icon={crumbs[0].icon} width={16} height={16} fill="primary" />
          <S.Label>{crumbs[0].labelPage}</S.Label>
        </S.Container>
      </S.Wrapper>
    )
  } else {
    return (
      <S.Wrapper>
        {crumbs.map(({ icon, labelPage, link }, key) => {
          const keyValidatitor = 2
          if (key === 0) return null
          if (key + 1 === crumbs.length) {
            return (
              <S.Container key={key}>
                {key >= keyValidatitor && <S.Divider>/</S.Divider>}
                {icon && key === keyValidatitor - 1 && (
                  <Icon icon={icon} width={16} height={16} fill="primary" />
                )}
                <S.Label>{labelPage}</S.Label>
              </S.Container>
            )
          } else {
            return (
              <Link key={key} to={link}>
                <S.Container>
                  {key >= keyValidatitor && <S.Divider>/</S.Divider>}
                  {icon && key === keyValidatitor - 1 && (
                    <Icon icon={icon} width={16} height={16} fill="primary" />
                  )}
                  <S.Label>{labelPage}</S.Label>
                </S.Container>
              </Link>
            )
          }
        })}
        {Boolean(suffix.length) && (
          <>
            <S.SuffixSeparator> - </S.SuffixSeparator>
            {suffix.map(({ label, value }) => (
              <S.Suffix key={label}>{`${label}: ${value}`}</S.Suffix>
            ))}
          </>
        )}
      </S.Wrapper>
    )
  }
}
